import { ChangePasswordErrorTypes, ReauthErrorKind } from '@griply/types';
import { LoginErrorTypes } from 'shared/types/login-form';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

// Outcomes a form already renders; each enum's `unknown` member stays reportable.
const expectedMutationErrors = new Set<string>([
  LoginErrorTypes.WrongCombination,
  ChangePasswordErrorTypes.WrongPassword,
  ChangePasswordErrorTypes.WeakPassword,
  ReauthErrorKind.WrongPassword,
  ReauthErrorKind.Cancelled,
  ResetPasswordErrorTypes.InvalidCode,
  ResetPasswordErrorTypes.WeakPassword,
]);

export const isExpectedMutationError = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return expectedMutationErrors.has(error);
  }

  const kind = (error as { kind?: unknown } | null)?.kind;

  return typeof kind === 'string' && expectedMutationErrors.has(kind);
};
